"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.DownChevronIcon = void 0;
const jsx_runtime_1 = require("react/jsx-runtime");
const constants_1 = require("../constants");
/**
 * Standard down chevron icon.
 */
function DownChevronIcon(props) {
    const { className, "data-testid": dataTestId, fill = "black", size = constants_1.Sizes.Large } = props;
    return ((0, jsx_runtime_1.jsx)("svg", { width: size, height: size, viewBox: "0 0 24 24", fill: fill, xmlns: "http://www.w3.org/2000/svg", className: className, "data-testid": dataTestId, children: (0, jsx_runtime_1.jsx)("path", { fillRule: "evenodd", clipRule: "evenodd", d: "M2.43934 7.93934C3.02513 7.35356 3.97487 7.35356 4.56066 7.93934L12 15.3787L19.4393 7.93934C20.0251 7.35355 20.9749 7.35355 21.5607 7.93934C22.1464 8.52513 22.1464 9.47487 21.5607 10.0607L13.0607 18.5607C12.4749 19.1464 11.5251 19.1464 10.9393 18.5607L2.43934 10.0607C1.85355 9.47488 1.85355 8.52513 2.43934 7.93934Z" }) }));
}
exports.DownChevronIcon = DownChevronIcon;
//# sourceMappingURL=DownChevronIcon.js.map